export const breakpoints = {
  xs: 600,
  sm: 960,
  md: 1264,
  lg: 1904,
};
